export default __webpack_public_path__ + "static/media/diploma2.8ef25ad6.jpg";